// /src/components/Menu.js
import React from "react";
import { Link, NavLink } from "react-router-dom";
import { AppBar, Toolbar, Button, Box, IconButton } from "@mui/material";
import LanguagePicker from "./LanguagePicker";
import { useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { logoutUser } from "../store/actions/authActions";
import logoWhite from "../assets/logo-white.png"; // Adjust the path to your logo image
import { useTranslation } from "react-i18next";
import { MdDashboard, MdSettings, MdPayment, MdDescription, MdLogout } from "react-icons/md";

const useStyles = makeStyles({
  link: {
    color: "inherit",
    textDecoration: "none",
    "&.active": {
      borderBottom: "2px solid white",
    },
    borderRadius: "0px !important",
  },
  logo: {
    maxHeight: "40px", // Adjust as needed
    marginRight: "16px",
    '@media (max-width: 600px)': {
      display: 'none',
    },
  },
  menuText: {
    display: 'inline',
    '@media (max-width: 600px)': {
      display: 'none',
    },
  },
  menuIcon: {
    display: 'none',
    '@media (max-width: 600px)': {
      display: 'inline-flex',
      verticalAlign: 'middle',
      fontSize: '1.5rem',
    },
  },
});

const Menu = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { t } = useTranslation(); // Get the t function

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  return (
    <AppBar position="static">
      <Toolbar>
        {/* Logo */}
        <IconButton
          edge="start"
          color="inherit"
          aria-label="logo"
          component={Link}
          to="/dashboard"
        >
          <img src={logoWhite} alt="Logo" className={classes.logo} />
        </IconButton>
        <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center" }}>
          <Button
            color="inherit"
            component={NavLink}
            to="/dashboard"
            className={classes.link}
          >
            <span className={classes.menuIcon}><MdDashboard /></span>
            <span className={classes.menuText}>{t("dashboard.title")}</span>
          </Button>
          <Button
            color="inherit"
            component={NavLink}
            to="/settings"
            className={classes.link}
          >
            <span className={classes.menuIcon}><MdSettings /></span>
            <span className={classes.menuText}>{t("settings.title")}</span>
          </Button>
          <Button
            color="inherit"
            component={NavLink}
            to="/billing"
            className={classes.link}
          >
            <span className={classes.menuIcon}><MdPayment /></span>
            <span className={classes.menuText}>{t("billing.title")}</span>
          </Button>
        </Box>
        {/* Spacer to push items to the right */}
        {/* <Box sx={{ flexGrow: 1 }} /> */}
        <Button
            color="inherit"
            component={NavLink}
            to="/documentation"
            className={classes.link}
          >
            <span className={classes.menuIcon}><MdDescription /></span>
            <span className={classes.menuText}>{t("documentation.title")}</span>
          </Button>
        <Button color="inherit" onClick={handleLogout} className="logoutButton">
          <span className={classes.menuIcon}><MdLogout /></span>
          <span className={classes.menuText}>{t("login.logout")}</span>
        </Button>
        <LanguagePicker sx={{ color: "white", borderColor: "white" }} />
      </Toolbar>
    </AppBar>
  );
};

export default Menu;
